// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperTitle-cls1_Q1o","cls2":"PaperTitle-cls2_S4- PaperTitle-cls1_Q1o"};